import {DeviceAttribute} from "./device-attribute.model";

export const LayoutID = {
  DataLogger: 1,
  ElectricityMeter: 2,
  Interface: 3,
  UniversalElectricityMeter: 4,
  ImpulseMeter: 5
};

export class DeviceType {

  public id?: number;
  public name?: string;
  public producer?: string;
  public type?: string;
  public function?: string;
  public modified?: string;
  public modifiedBy?: string;
  public layout?: number;
  public attributes?: DeviceAttribute[];

  constructor (data?: any) {
    if (data) {
      this.id = data.id;
      this.layout = data.layout;
      this.name = data.name;
      this.producer = data.producer;
      this.type= data.type;
      this.function= data.function;
      this.modified = data.modified;
      this.modifiedBy = data.modifiedBy;
      if (data.attributes) {
        this.attributes = data.attributes.map(attribute => new DeviceAttribute(attribute))
      }
    }
  }
}
